<div class="fb-section" [class.collapsed]="isCollapsed">
  <div class="fb-section__header">
    <button class="fb-section__collapse-btn" (click)="toggleCollapse()">
      <i
        [class]="
          isCollapsed ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-down'
        "></i>
    </button>
    <div class="fb-section__drag-handle">
      <i class="fa-solid fa-grip-vertical"></i>
    </div>
    <irembogov-fb-inline-edit
      [value]="sectionLabel"
      placeholder="Section title"
      tag="h6"
      (valueChange)="onSectionLabelChange($event)">
    </irembogov-fb-inline-edit>
    <span class="fb-section__count" *ngIf="isCollapsed">
      {{ blocks.length }} block{{ blocks.length !== 1 ? 's' : '' }},
      {{ totalFieldCount }} field{{ totalFieldCount !== 1 ? 's' : '' }}
    </span>
    <div class="fb-section__actions">
      <button
        class="fb-section__action-btn"
        title="Section settings"
        (click)="configure(); $event.stopPropagation()">
        <i class="fa-solid fa-gear"></i>
      </button>
      <button
        class="fb-section__action-btn fb-section__action-btn--danger"
        title="Delete section"
        (click)="onDeleteSection()">
        <i class="fa-solid fa-trash"></i>
      </button>
    </div>
  </div>
  <div class="fb-section__content" *ngIf="!isCollapsed">
    <div
      [sortablejs]="blocks"
      [sortablejsOptions]="blockSortableOptions"
      class="fb-section__blocks">
      <irembogov-fb-block
        *ngFor="let block of blocks; let bi = index; trackBy: trackByBlockKey"
        [block]="block"
        [sectionIndex]="sectionIndex"
        [blockIndex]="bi"
        [selectedFieldKey]="selectedFieldKey"
        (fieldSelected)="onFieldSelected($event)"
        (blockChanged)="onBlockChanged()"
        (deleteBlockEvent)="onDeleteBlock($event)">
      </irembogov-fb-block>
    </div>
    <button class="fb-section__add-block-btn" (click)="onAddBlock()">
      <i class="fa-solid fa-plus"></i> Add Block
    </button>
  </div>
</div>
